/**
 * @Author: 仙道
 * @Date: 2022-07-11 23:10:03
 * @LastEditTime: 2023-09-05 00:49:45
 * @email: hao.li08@weimob.com
 * @Description:
 * @FilePath: /iplus-iwt-fe/src/mixins/DragTableMixin.js
 **/
import Sortable from 'sortablejs'
import { postAction } from '@/api/manage'

export const DragTableMixin = {
  // 定义属性
  data() {
    return {
      // listPagination: {
      //   pageSize: 50,
      //   pageSizeOptions: ['50', '100', '200', '300']
      // },
      // pageSizeOptions: ['50', '100', '200', '300'],
      DragTableloading: false,
      // isorter: {
      //   column: 'sort',
      //   order: 'ascend'
      // },
      sortTable: null
    }
  },
  // 计算属性，会监听依赖属性值随之变化

  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    if (!this.DragTableloading) {
      this.$nextTick(() => {
        this.initSortable()
      })
    }
    //
  },
  // 方法集合
  methods: {
    initSortable() {
      this.DragTableloading = true
      let mytb = document.querySelector('tbody')
      if (this.dragTableClass) {
        const pointTable = document.querySelector(`.${this.dragTableClass}`)
        mytb = pointTable.querySelector('tbody')
      }
      // const mytb = document.querySelector('tbody')
      const _this = this
      const sortTable = Sortable.create(mytb, {
        handle: '.ant-table-row',
        animation: 150,
        ghostClass: 'blue-background-class',
        chosenClass: 'sortable-chosen', // 被选中项的css 类名
        //  handle: '.drag-btn',
        sort: true,
        onEnd({ newIndex, oldIndex }) {
          const pagination = _this.ipagination
          const record = _this.dataSource[oldIndex]
          const newRecord = _this.dataSource[newIndex]
          const currRow = _this.dataSource.splice(oldIndex, 1)[0]
          _this.dataSource.splice(newIndex, 0, currRow)

          const newSerialNumber = (pagination.current - 1) * pagination.pageSize + newIndex
          const oldSerialNumber = (pagination.current - 1) * pagination.pageSize + oldIndex
          if (_this.url.sort) {
            postAction(_this.url.sort, {
              id: record.id,
              newSerialNumber,
              oldSerialNumber
            }).then(res => {
              if (res.success) {
                _this.$message.success(res.message)
              } else {
                _this.$message.error(res.message)
              }
            })
          } else {
            _this.tableSortFn(record, newSerialNumber, oldSerialNumber)
          }
          // message.success(
          //   "排序完成！！！！位置从" + oldIndex + "移动到" + newIndex
          // );
        }
      })
      if (this.dragTableClass) {
        this.sortTable = sortTable
      }
    },
    destroyed() {
      this.sortTable?.destroy()
    },
    rowClick: function(record, index) {
      return {
        on: {
          click: event => {
            console.log(record, index, event, '666')
          },

          dblclick: () => {
            console.log('双击了我')
          }

          // ...
        }
      }
    }
  }
}
